import axios from 'axios';
import route from '@H/route';
import router from '@R';
import { getErrorFromResponse } from '@H/error-codes';

export default {
    getSubscriptions(ctx) {
        return new Promise((resolve, reject) => {
            axios
                .post(route('mysubs.get-subscriptions'), {})
                .then(res => {
                    let subscriptions = res.data.subscriptions;

                    ctx.commit('Widget/setSubscriptions', subscriptions, { root: true });

                    resolve(subscriptions);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    getPaymentAttempts(ctx) {
        return new Promise((resolve, reject) => {
            axios
                .post(route('mysubs.payment-attempts'))
                .then(res => {
                    ctx.commit('Widget/setPaymentAttempts', res.data, { root: true });
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },

    async initiateSubscriptionUpgrade(ctx) {
        ctx.commit('setFormSubmitting', true, { root: true });

        try {
            let res = await axios.post(route('mysubs.upgrade-subscription'), ctx.rootState.Enrolment.user);

            ctx.commit('setFormSubmitting', false, { root: true });

            // Redirect to the view that loads in the trustpay iframe
            return router.push({ name: 'my-subscriptions-payment'});
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err, err.message) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },

    async loadPaymentConfirmation(ctx) {
        let { $gettext } = this._vm;
        let params = {
            subscriptionUpgradeId: ctx.rootState.Widget.subscriptionUpgradeId 
        };

        try {
            let res = await axios.get(route('mysubs.payment-confirmation'), { params })

            ctx.commit('Widget/payment', res.data.payment, { root : true });

            return res.data.payment;
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                $gettext('There was a problem loading payment data.'),
                { root: true }
            );

            throw new Error(err);
        }
    },

    async sendConfirmationEmail(ctx) {
        let { $gettext } = this._vm;

        // Grab the full subscription and purchase option objects by using the selectedUpgrade to filter the full arrays down to just one:
        let subscription = ctx.rootState.Widget.subscriptions.find(subscription => subscription.subscriptionId == ctx.rootState.Widget.selectedUpgrade.subscriptionId),
            purchaseOption = subscription.pricing.find(pricing => pricing.Id == ctx.rootState.Widget.selectedUpgrade.pricingOption.id);

        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.post(route('mysubs.subscription-confirmation-email'), {
                    subscription: subscription,
                    purchaseOption: purchaseOption
                })

                resolve(res.data);
            } catch (err) {
                ctx.dispatch(
                    'Flash/setFlash',
                    $gettext('There was a problem loading payment data.'),
                    { root: true }
                );

                reject(err);
            }
        });
    },

    async sendTeaserEmail(ctx) {
        let { $gettext } = this._vm;

        // Grab the full subscription and purchase option objects by using the selectedUpgrade to filter the full arrays down to just one:
        let subscription = ctx.rootState.Widget.subscriptions.find(subscription => subscription.subscriptionId == ctx.rootState.Widget.selectedUpgrade.subscriptionId),
            purchaseOption = subscription.pricing.find(pricing => pricing.Id == ctx.rootState.Widget.selectedUpgrade.pricingOption.id);

        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.post(route('mysubs.subscription-teaser-email'), {
                    subscription: subscription,
                    purchaseOption: purchaseOption
                })

                resolve(res.data);
            } catch (err) {
                ctx.dispatch(
                    'Flash/setFlash',
                    $gettext('There was a problem loading payment data.'),
                    { root: true }
                );

                reject(err);
            }
        });
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/MySubscriptions/actions.js